export const MAX_DOT_SIZE = 120;

export const getScaleValue = (n: number) => n / MAX_DOT_SIZE;
